import { render, staticRenderFns } from "./PhotoViewerItem.vue?vue&type=template&id=234a8d53"
import script from "./PhotoViewerItem.vue?vue&type=script&lang=js"
export * from "./PhotoViewerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports